<template>
  <div class="bracelets">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <h1>终端管理</h1>
          <div class="bracelet-management">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-button type="primary" @click="handleAdd">新增终端</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="danger" @click="handleDelete">删除终端</el-button>
              </el-col>
              <el-col :span="6">
                <el-button type="info" @click="handleFindLocation">批量查询位置</el-button>
              </el-col>
              <el-col :span="6">
                <el-input
                  v-model="searchQuery"
                  placeholder="搜索终端 ID"
                  clearable
                  @clear="handleSearchClear"
                />
              </el-col>
            </el-row>

            <el-table
              :data="filteredBracelets"
              style="width: 100%; margin-top: 20px;"
              @selection-change="handleSelectionChange"
              empty-text="暂无终端"
            >
              <el-table-column type="selection" width="55" />
              <el-table-column prop="id" label="终端 ID" sortable />
              <el-table-column prop="battery" label="电量" sortable>
                <template #default="scope">
                  <el-tag v-if="scope.row.battery === null" type="info">未知</el-tag>
                  <span v-else>{{ scope.row.battery }}%</span>
                </template>
              </el-table-column>
              <el-table-column prop="charging" label="充电状态" sortable >
                <template #default="scope">
                  <el-tag :type="scope.row.charging === null ? 'info' : (scope.row.charging ? 'success' : 'info')">
                    {{ scope.row.charging === null ? '未知' : (scope.row.charging ? '充电中' : '未充电') }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="signal" label="信号强度" sortable>
                <template #default="scope">
                  <el-tag v-if="scope.row.signal === null" type="danger">离线</el-tag>
                  <el-tag v-else-if="scope.row.signal >= -70" type="success">{{ scope.row.signal }} dBm</el-tag>
                  <el-tag v-else type="warning">{{ scope.row.signal }} dBm</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="ip" label="IP 地址" sortable />
              <el-table-column prop="status" label="使用状态" sortable >
                <template #default="scope">
                  <!-- <el-tag :type="scope.row.status === '未使用' ? 'success' : 'danger'">
                    {{ scope.row.status }}
                  </el-tag> -->
                  <el-tag v-if="scope.row.status === '未使用'" type="success">{{ scope.row.status }}</el-tag>
                  <el-tag v-else-if="scope.row.status === '使用中'" type="warning">{{ scope.row.status }}</el-tag>
                  <el-tag v-else type="danger">{{ scope.row.status }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="userName" label="借出人" />
              <el-table-column prop="userPhone" label="电话" />
              <el-table-column label="操作">
                <template #default="scope">
                  <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                  <el-button type="text" @click="handleFindBracelet(scope.row)">找终端</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
  
  <el-dialog
    v-model="dialogVisible"
    :title="editMode ? '编辑终端' : '新增终端'"
    width="30%"
  >
    <el-form :model="newBracelet" label-width="100px">
      <el-form-item label="终端 ID">
        <el-input v-model="newBracelet.id" disabled />
      </el-form-item>
      <el-form-item label="IP 地址">
        <el-input v-model="newBracelet.ip"/>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="newBracelet.status" @change="handleStatusChange">
          <el-option label="未使用" value="未使用" />
          <el-option label="使用中" value="使用中" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="newBracelet.status === '使用中'" label="借出人">
        <el-input v-model="newBracelet.userName" placeholder="请输入借出人" />
      </el-form-item>
      <el-form-item v-if="newBracelet.status === '使用中'" label="电话">
        <el-input v-model="newBracelet.userPhone" placeholder="请输入借出人电话" />
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleCancelAdd">取消</el-button>
        <el-button type="primary" @click="handleConfirmAdd">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'BraceletManagement',
  data() {
    return {
      dialogVisible: false,
      editMode: false, // 区分编辑和新增模式
      newBracelet: {
        id: '',
        battery: 100,
        status: '未使用',
        distance: null,
        signal: null,
        ip: '',
        userName: '',
        userPhone: '',
        charging: false
      },
      bracelets: [
        { id: '001', battery: 95, status: '未使用', distance: 12, signal: -45, ip: '192.168.1.1', userName: '', userPhone: '', charging: false },
        { id: '002', battery: 60, status: '使用中', distance: 45, signal: -65, ip: '192.168.1.2', userName: '王芳', userPhone: '13987654321', charging: false },
        { id: '003', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '004', battery: 100, status: '未使用', distance: 67, signal: -50, ip: '192.168.1.4', userName: '', userPhone: '', charging: true },
        { id: '005', battery: 50, status: '使用中', distance: 3, signal: -70, ip: '192.168.1.5', userName: '赵强', userPhone: '13655667788', charging: false },
        { id: '006', battery: 85, status: '未使用', distance: 22, signal: -55, ip: '192.168.1.6', userName: '', userPhone: '', charging: true },
        { id: '007', battery: 40, status: '使用中', distance: 78, signal: -75, ip: '192.168.1.7', userName: '王伟', userPhone: '13311223344', charging: false },
        { id: '008', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '009', battery: 55, status: '未使用', distance: 50, signal: -60, ip: '192.168.1.9', userName: '', userPhone: '', charging: true },
        { id: '010', battery: 82, status: '未使用', distance: 18, signal: -89, ip: '192.168.1.10', userName: '', userPhone: '', charging: true },
        { id: '011', battery: 33, status: '使用中', distance: 93, signal: -63, ip: '192.168.1.11', userName: '李敏', userPhone: '13566778899', charging: false },
        { id: '012', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '013', battery: 97, status: '未使用', distance: 7, signal: -92, ip: '192.168.1.13', userName: '', userPhone: '', charging: false },
        { id: '014', battery: 45, status: '使用中', distance: 125, signal: -58, ip: '192.168.1.14', userName: '陈超', userPhone: '13123456789', charging: false },
        { id: '015', battery: 76, status: '未使用', distance: 34, signal: -78, ip: '192.168.1.15', userName: '', userPhone: '', charging: true },
        { id: '016', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '017', battery: 28, status: '使用中', distance: 88, signal: -65, ip: '192.168.1.17', userName: '周静', userPhone: '13755664433', charging: false },
        { id: '018', battery: 91, status: '未使用', distance: 11, signal: -93, ip: '192.168.1.18', userName: '', userPhone: '', charging: false },
        { id: '019', battery: 55, status: '使用中', distance: 62, signal: -72, ip: '192.168.1.19', userName: '吴勇', userPhone: '13900112233', charging: false },
        { id: '020', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '021', battery: 100, status: '未使用', distance: 2, signal: -98, ip: '192.168.1.21', userName: '', userPhone: '', charging: true },
        { id: '022', battery: 39, status: '使用中', distance: 107, signal: -60, ip: '192.168.1.22', userName: '孙丽', userPhone: '13800998877', charging: false },
        { id: '023', battery: 84, status: '未使用', distance: 29, signal: -46, ip: '192.168.1.23', userName: '', userPhone: '', charging: false },
        { id: '024', battery: 63, status: '使用中', distance: 74, signal: -68, ip: '192.168.1.24', userName: '郑杰', userPhone: '13612341234', charging: false },
        { id: '025', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '026', battery: 95, status: '未使用', distance: 14, signal: -57, ip: '192.168.1.26', userName: '', userPhone: '', charging: true },
        { id: '027', battery: 47, status: '使用中', distance: 83, signal: -62, ip: '192.168.1.27', userName: '王杰', userPhone: '13943214321', charging: false },
        { id: '028', battery: 79, status: '未使用', distance: 41, signal: -66, ip: '192.168.1.28', userName: '', userPhone: '', charging: false },
        { id: '029', battery: 58, status: '使用中', distance: 96, signal: -70, ip: '192.168.1.29', userName: '林涛', userPhone: '13567896789', charging: false },
        { id: '030', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null },
        { id: '031', battery: 88, status: '未使用', distance: 55, signal: -43, ip: '192.168.1.31', userName: '', userPhone: '', charging: true },
        { id: '032', battery: null, status: '未知', distance: null, signal: null, ip: null, userName: '', userPhone: '', charging: null }
      ],
      searchQuery: '',
      selectedBracelets: []
    };
  },
  computed: {
    filteredBracelets() {
      return this.bracelets.filter(bracelet => {
        return bracelet.id.includes(this.searchQuery);
      });
    }
  },
  methods: {
    handleAdd() {
      const newId = String(this.bracelets.length + 1).padStart(3, '0');
      const newIp = `192.168.1.${String(this.bracelets.length + 1)}`;
      this.newBracelet = {
        id: newId,
        battery: Math.floor(Math.random() * 41) + 60, // 生成60到100之间的随机整数
        status: '未使用',
        distance: null,
        signal: Math.floor(Math.random() * 36) - 80, // 生成-45到-80之间的随机整数
        ip: newIp,
        userName: '',
        userPhone: '',
        charging: false
      };
      this.dialogVisible = true;
    },
    handleConfirmAdd() {
      if (this.newBracelet.status === '使用中' && (!this.newBracelet.userName || !this.newBracelet.userPhone)) {
        this.$message.error("请输入借出人和电话");
        return;
      }
      this.bracelets.push({ ...this.newBracelet });
      this.$message.success(`新增终端 ${this.newBracelet.id} 成功`);
      this.dialogVisible = false;
    },
    handleStatusChange(status) {
      if (status !== '使用中') {
        this.newBracelet.userName = '';
        this.newBracelet.userPhone = '';
      }
    },
    handleCancelAdd() {
      this.dialogVisible = false;
    },
    handleDelete() {
      if (this.selectedBracelets.length === 0) {
        this.$message.warning('请选择要删除的终端');
        return;
      }
      // 过滤掉选中的终端
      this.bracelets = this.bracelets.filter(bracelet => 
        !this.selectedBracelets.some(selected => selected.id === bracelet.id)
      );
      this.selectedBracelets = []; // 清空选中状态
      this.$message.success('删除终端成功');
    },
    handleFindLocation() {
      if (this.selectedBracelets.length === 0) {
        this.$message.warning('请选择要查询的终端');
        return;
      }
      this.$message.success('选中的终端正在响铃');
    },
    handleSearchClear() {
      this.searchQuery = '';
    },
    handleSelectionChange(selection) {
      this.selectedBracelets = selection;
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.editMode = true; // 设置为编辑模式
      this.newBracelet = { ...row }; // 填充当前行数据到表单
    },
    handleConfirmAdd() {
      if (this.newBracelet.status === '使用中' && (!this.newBracelet.userName || !this.newBracelet.userPhone)) {
        this.$message.error("请输入借出人和电话");
        return;
      }
      if (this.editMode) {
        const index = this.bracelets.findIndex(b => b.id === this.newBracelet.id);
        if (index !== -1) {
          this.bracelets.splice(index, 1, { ...this.newBracelet }); // 更新现有数据
          this.$message.success(`终端 ${this.newBracelet.id} 信息已更新`);
        }
      } else {
        this.bracelets.push({ ...this.newBracelet }); // 新增数据
        this.$message.success(`新增终端 ${this.newBracelet.id} 成功`);
      }
      this.dialogVisible = false;
      this.editMode = false; // 重置编辑状态
    },
    handleFindBracelet(bracelet) {
      this.$message.success(`目标终端 ${bracelet.id} 正在响铃`);
    }
  }
};
</script>

<style scoped>
.bracelets {
  padding: 20px;
}

.bracelet-management {
  margin-top: 20px;
}
</style>
